import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { useParams } from 'react-router';
import { configApiRef, useAnalytics, useApi } from '@backstage/core-plugin-api';
import { MarkdownContent } from '@appfolio/backstage-components';
import { makeStyles } from '@material-ui/core';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import { useExtendedTechDocsMetadata } from '../../../../hooks/useExtendedTechDocsMetadata';

const useStyles = makeStyles({
  relatedPageListItemText: {
    '& p': {
      margin: 0,
    },
  },
});

export const RelatedPages = () => {
  const analytics = useAnalytics();
  const classes = useStyles();
  const config = useApi(configApiRef);
  const { '*': path = '' } = useParams();
  const context = useTechDocsReaderPage();
  const { relatedPages, isLoading } = useExtendedTechDocsMetadata(
    context.entityRef,
    path,
  );
  if (
    isLoading ||
    context.entityMetadata.loading ||
    typeof context.entityMetadata.value === 'undefined'
  ) {
    return;
  }
  const baseUrl = new URL(
    entityUtil(context.entityMetadata.value).getDocsUrlPath(),
    config.getString('app.baseUrl'),
  ).toString();
  return (
    <>
      <Typography component="h2">Recommended pages</Typography>
      {relatedPages.length ? (
        <List style={{ padding: 0, margin: 0 }}>
          {relatedPages.map(r => {
            const pageUrl = `${baseUrl}${r.path}`;
            return (
              <ListItem
                key={r.path}
                component="a"
                href={pageUrl}
                style={{ paddingLeft: 0, paddingRight: 0 }}
                onClick={() => {
                  analytics.captureEvent('click', 'recommended page', {
                    attributes: { to: pageUrl },
                  });
                }}
              >
                <ListItemText
                  className={classes.relatedPageListItemText}
                  primary={
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{ marginBottom: 8 }}
                    >
                      {r.type ? (
                        <Chip
                          size="small"
                          label={r.type}
                          variant="outlined"
                          style={{
                            marginRight: 8,
                            marginBottom: 0,
                          }}
                        />
                      ) : null}
                      <Typography variant="body1">
                        <MarkdownContent>{r.title}</MarkdownContent>
                      </Typography>
                    </Box>
                  }
                  secondary={
                    r.description ? (
                      <MarkdownContent>{r.description}</MarkdownContent>
                    ) : null
                  }
                />
              </ListItem>
            );
          })}
        </List>
      ) : (
        <Typography paragraph>
          <em>This page does not have any recommendations.</em>
        </Typography>
      )}
    </>
  );
};
